import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgStake = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#stake_svg__a)">
      <path
        fill="currentColor"
        d="M21.593 13.224a2.29 2.29 0 0 0-1.99-.396l-3.923.902a2.625 2.625 0 0 0-2.555-3.23H8.432a2.98 2.98 0 0 0-2.122.878L4.19 13.5H1.5A1.5 1.5 0 0 0 0 15v3.75a1.5 1.5 0 0 0 1.5 1.5h9.75a.7.7 0 0 0 .182-.023l6-1.5a1 1 0 0 0 .111-.037l3.645-1.55.04-.02a2.306 2.306 0 0 0 .37-3.896zM1.5 15h2.25v3.75H1.5zm19.072.77-3.563 1.517-5.853 1.463H5.25v-4.19l2.122-2.12a1.49 1.49 0 0 1 1.06-.44h4.693a1.125 1.125 0 1 1 0 2.25H10.5a.75.75 0 1 0 0 1.5h3a.8.8 0 0 0 .168-.019l6.281-1.444.03-.008a.806.806 0 0 1 .59 1.49zM15.375 9q.278 0 .553-.045a3.376 3.376 0 1 0 2.646-4.406A3.375 3.375 0 1 0 15.375 9M21 7.875a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0M15.375 3.75a1.875 1.875 0 0 1 1.805 1.37 3.38 3.38 0 0 0-1.407 2.337q-.196.042-.398.043a1.875 1.875 0 1 1 0-3.75"
      />
    </g>
    <defs>
      <clipPath id="stake_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgStake);
export default ForwardRef;
